import moment from "moment";
import { Link } from "react-router-dom";

export default function FooterComponent() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-lg font-bold text-white">ExpenseHut</span>
            </div>
            <p className="text-sm">Modern POS for modern businesses.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://business.expensehut.com"
                  className="hover:text-white transition"
                >
                  Point Of Sale
                </a>
              </li>
              <li>
                <a
                  href="https://www.expensehut.com/kiosks"
                  className="hover:text-white transition"
                >
                  Super Kiosks
                </a>
              </li>
              <li>
                <a
                  href="https://www.expensehut.com/pricing"
                  className="hover:text-white transition"
                >
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-white transition">
                  About
                </Link>
              </li>
              <li>
                <a
                  href="https://blogs.expensehut.com"
                  className="hover:text-white transition"
                >
                  Blogs
                </a>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://help.expensehut.com/privacy"
                  className="hover:text-white transition"
                >
                  Privacy
                </a>
              </li>
              <li>
                <a
                  href="https://help.expensehut.com/terms"
                  className="hover:text-white transition"
                >
                  Terms
                </a>
              </li>
              <li>
                <a
                  href="https://help.expensehut.com/cookies"
                  className="hover:text-white transition"
                >
                  Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>
            &copy; {moment().format("YYYY")} ExpenseHut. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
